/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceListList
 */
export interface PriceListList {
    /**
     * 
     * @type {number}
     * @memberof PriceListList
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PriceListList
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof PriceListList
     */
    validFrom: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PriceListList
     */
    draft: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PriceListList
     */
    active: boolean;
}

/**
 * Check if a given object implements the PriceListList interface.
 */
export function instanceOfPriceListList(value: object): value is PriceListList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('draft' in value) || value['draft'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function PriceListListFromJSON(json: any): PriceListList {
    return PriceListListFromJSONTyped(json, false);
}

export function PriceListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceListList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'validFrom': (new Date(json['validFrom'])),
        'draft': json['draft'],
        'active': json['active'],
    };
}

export function PriceListListToJSON(json: any): PriceListList {
    return PriceListListToJSONTyped(json, false);
}

export function PriceListListToJSONTyped(value?: PriceListList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'validFrom': ((value['validFrom']).toISOString()),
        'draft': value['draft'],
        'active': value['active'],
    };
}

